// extracted by mini-css-extract-plugin
export var createdDate = "_nx-1";
export var divider = "_nx-2";
export var headerDivider = "_nx-3";
export var messagesCard = "_nx-0";
export var messagesContainer = "_nx-6";
export var messagesContainerWrapper = "_nx-4";
export var showLeftPanelButton = "_nx-8";
export var topButtons = "_nx-7";
export var withPadding = "_nx-5";